module.exports = __webpack_public_path__ + "img/loons_03.57ceb503.png";